import React from "react";
import { WidgetFilters } from "../../utils/WidgetFilters";
import { useBarChartConfig } from "./ConfigForm_Context";

export const ConfigForm_FiltersSection = ({
  addFilterAnchorEl,
  addFilterLightboxOpen,
  onAddFilterLightboxOpenChange,
  onClearFilters,
  onHasFiltersToClear,
  onHasFilterConfigs,
  hasDimensions,
}) => {
  const {
    widgetConfig,
    setConfig,
    underEditWidgetIdx,
    contentTypesForFilters,
  } = useBarChartConfig();

  return (
    <WidgetFilters
      widgetConfig={widgetConfig}
      updateWidgetConfig={setConfig}
      widgetIndex={underEditWidgetIdx}
      contentTypesForFilters={contentTypesForFilters}
      addFilterAnchorEl={addFilterAnchorEl}
      addFilterLightboxOpen={addFilterLightboxOpen}
      onAddFilterLightboxOpenChange={onAddFilterLightboxOpenChange}
      onClearFilters={onClearFilters}
      onHasFiltersToClear={onHasFiltersToClear}
      onHasFilterConfigs={onHasFilterConfigs}
      hasDimensions={hasDimensions}
    />
  );
};
